module.exports = __webpack_public_path__ + "img/dingdans.e6780d15.svg";